module.exports = __webpack_public_path__ + "img/a_l1.e3c5a921.png";